<template>
  <section class="page-interaction rewards-page boho-rewards">
    <b-overlay
      :show="loading"
      no-center
      variant="transparent"
      rounded="sm"
    >
      <template #overlay>
        <loading-spinner />
      </template>

      <b-container class="daily-task" fluid>
        <b-row v-if="false && notification">
          <b-col cols="12">
            <div class="reward-notification-container">
              <div class="reward-notification">
                <div class="image-container">
                  <img :src="notificationsBg" />
                </div>
                <div class="reward-notification-content">
                  <div class="reward-notification-title" v-html="notification.title" />
                  <p class="reward-notification-text" v-html="notification.text" />
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="false">
          <b-col
            v-if="activeMissions"
            cols="12"
          >
            <b-card>
              <h4 class="text-center mb-0">
                {{ activeMissions.title }}
              </h4>
            </b-card>
          </b-col>
        </b-row>

        <b-row
          v-if="false"
          class="align-items-stretch"
        >
          <b-col
            class="d-flex"
            lg="12"
            cols="12"
          >
            <b-card class="w-100">
              <div
                class="p-1 d-flex justify-content-end align-items-center"
                style="gap: 8px"
              >
                <router-link
                  v-if="showCallTaskListLink"
                  :to="{name: mobile ? 'mobile-for-you' : 'for-you-2'}"
                >
                  <button
                    class="btn-primary2"
                    style="font-size: 14px; padding: 8px 11px;"
                  >
                    {{ $t('Call Task List') }}
                  </button>
                </router-link>
                <router-link
                  v-if="false && showBonusCampaignLink"
                  :to="{name: mobile ? 'mobile-bonus-campaign' : 'bonus-campaign'}"
                >
                  <button
                    class="btn-primary2"
                    style="font-size: 14px; padding: 8px 12px"
                  >
                    {{ $t('Coupon Bonus Campaign') }}
                  </button>
                </router-link>
                <router-link
                  v-if="showBonusOutcallLink"
                  :to="{name: mobile ? 'mobile-bonus-outcall' : 'bonus-outcall'}"
                >
                  <button
                    class="btn-primary2"
                    style="font-size: 14px; padding: 8px 12px"
                  >
                    {{ $t('Outcall Campaign') }}
                  </button>
                </router-link>
              </div>
            </b-card>
          </b-col>
        </b-row>

        <b-row class="align-items-stretch">
          <b-col
            xl="4"
            lg="6"
            cols="12"
          >
            <!-- Daily task title -->
            <div
              v-if="false && incentiveDailyNewTask"
              class="daily-task-title"
            >
              <div class="daily-task-earnings-amount">
                <b-img
                  src="@/assets/images/icons/bean.png"
                  width="22"
                />
                {{ totalEarn }}
              </div>
              <p class="earnings-text">
                {{ incentiveDailyNewTask.title }}
              </p>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            lg="6"
            cols="12"
            class="justify-content-center mb-2"
          >
            <div
              v-if="dataMissionsWelcomeBeans"
              class="p-relative campaign-banner-container"
            >
              <div class="campaign-banner bg-1">
                <p>
                  {{ dataMissionsWelcomeBeans.content }}
                </p>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            lg="6"
            cols="12"
            class="justify-content-center"
          >
            <div
              v-if="dataMissionsWelcomeBeans"
              class="p-relative campaign-banner-container"
            >
              <div class="campaign-banner bg-2">
                <div v-if="dataMissionsWelcomeBeans.title" class="top-text">
                  {{ dataMissionsWelcomeBeans.title }}
                </div>
                <p v-if="dataMissionsWelcomeBeans.description">
                  {{ dataMissionsWelcomeBeans.description }}
                </p>
                <div
                  v-if="typeof dataMissionsWelcomeBeans.target !== 'undefined' && typeof dataMissionsWelcomeBeans.completed !== 'undefined'"
                  class="reward-progress"
                  style="width: 90%"
                >
                  <b-img
                    src="@/assets/images/icons/bean.png"
                    width="32"
                    class="reward-progress-bean"
                  />
                  <b-progress
                    variant="success"
                    :max="dataMissionsWelcomeBeans.target"
                    animated
                    striped
                    height="2rem"
                  >
                    <b-progress-bar :value="dataMissionsWelcomeBeans.completed">
                      <div class="reward-progress-bar">
                        {{ dataMissionsWelcomeBeans.completed }} / {{ dataMissionsWelcomeBeans.target }}
                      </div>
                    </b-progress-bar>
                  </b-progress>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="inactiveReason">
          <b-col
            lg="6"
            cols="12"
          >
            <div class="inactive-reason-alert">
              <feather-icon icon="AlertCircleIcon" size="16" class="inactive-reason-icon" />
              {{ inactiveReason }}
            </div>
          </b-col>
        </b-row>

        <b-row
          v-if="incentiveDailyNewTask || specialContentAvailable || memberTabs.length"
          class="align-items-stretch"
        >
          <b-col
            lg="6"
            cols="12"
          >
            <!-- Member Type Tabs -->
            <div class="member-tabs">
              <div
                v-for="tab in displayMemberTabs"
                :key="tab.key"
                class="member-tab-btn"
                :class="{ active: dailyTasksType === tab.key }"
                @click="changeMemberType(tab.key)"
              >
                {{ tab.label }}
              </div>
            </div>
          </b-col>
        </b-row>

        <div v-if="dailyTasksType === 'special_contents'" class="special-contents-tab">
          <SpecialContentsManager />
        </div>

        <ReferralCodes v-if="dailyTasksType === 'referral_codes'" />

        <b-row v-if="incentiveDailyNewTask && memberTabs.length > 0 && dailyTasksType !== 'special_contents' && dailyTasksType !== 'referral_codes'">
          <b-col
            lg="6"
            cols="12"
          >
            <div class="daily-task-title">
              🎉
              {{ incentiveDailyNewTask.description }}
              🎉
            </div>
          </b-col>
        </b-row>

        <!-- Kullanıcı listesi: sadece liste, görev değil (generally, pending_chat) - görev kartlarıyla aynı layout -->
        <b-row
          v-if="(dailyTasksType === 'generally' || dailyTasksType === 'pending_chat') && Array.isArray(dailyTasksUsers) && dailyTasksUsers.length > 0"
          :key="`user-list-${dailyTasksType}`"
        >
          <b-col
            lg="6"
            cols="12"
          >
            <div class="rewards-user-list">
              <div class="rewards-user-list-grid">
            <div
              v-for="(dailyTaskUser, i) in dailyTasksUsers"
              :key="dailyTaskUser.uuid"
              class="rewards-user-card"
              @click="chat(dailyTaskUser, i)"
            >
              <div class="rewards-user-card__avatar-wrap">
                <b-avatar
                  size="56"
                  :src="dailyTaskUser.avatar_url"
                  class="rewards-user-card__avatar badge-minimal"
                  :badge="!!dailyTaskUser.is_connected"
                  :badge-variant="dailyTaskUser.is_connected ? 'success' : 'secondary'"
                >
                  <feather-icon
                    v-if="!dailyTaskUser.avatar_url"
                    icon="UserIcon"
                    size="28"
                  />
                </b-avatar>
              </div>
              <div class="rewards-user-card__info">
                <div class="rewards-user-card__info-top">
                  <span class="rewards-user-card__name">{{ dailyTaskUser.user_name }}</span>
                  <span
                    v-if="activityStatus(dailyTaskUser)"
                    class="rewards-user-card__status"
                    :class="`rewards-user-card__status--${activityStatus(dailyTaskUser).key}`"
                  >
                    {{ activityStatus(dailyTaskUser).label }}
                  </span>
                </div>
                <div class="rewards-user-card__meta">
                  <b-img
                    v-if="dailyTaskUser.user_country && getImageFromCountry(dailyTaskUser.user_country)"
                    :src="getImageFromCountry(dailyTaskUser.user_country)"
                    width="40"
                    height="30"
                    class="rewards-user-card__flag"
                  />
                </div>
              </div>
              <div class="rewards-user-card__actions">
                <!-- camera_on true -> görüntülü; camera_on false ve voice_on true -> sesli -->
                <div
                  v-if="dailyTaskUser.camera_on"
                  class="rewards-user-card__action rewards-user-card__action--call"
                  @click.stop="videoCall(dailyTaskUser, i)"
                >
                  <feather-icon icon="VideoIcon" size="20" />
                </div>
                <div
                  v-else-if="dailyTaskUser.voice_on"
                  class="rewards-user-card__action rewards-user-card__action--call"
                  @click.stop="call(dailyTaskUser, i)"
                >
                  <feather-icon icon="PhoneIcon" size="20" />
                </div>
                <!-- Mesaj ikonunun tıklama işleyicisi yoktu -->
                <div
                  class="rewards-user-card__action"
                  @click.stop="chat(dailyTaskUser, i)"
                >
                  <feather-icon icon="MessageCircleIcon" size="20" />
                </div>
              </div>
            </div>
          </div>
          <div
            ref="userListSentinel"
            class="rewards-user-list-sentinel"
          />
          <div
            v-if="userListLoadingMore"
            class="rewards-user-list-loading"
          >
            <b-spinner small />
            <span>{{ $t('Loading') }}...</span>
          </div>
          <div
            v-if="!userListHasMore && dailyTasksUsers.length > 0"
            class="rewards-user-list-end"
          >
            {{ $t('All users loaded') }}
          </div>
            </div>
          </b-col>
        </b-row>

        <!-- Görev tab’ları için mevcut kart tasarımı (in_progress, bohemian vb.) -->
        <div :key="`task-users-${dailyTasksType}`" v-if="Array.isArray(dailyTasksUsers) && dailyTasksUsers.length > 0 && memberTabs.length > 0 && dailyTasksType !== 'general' && dailyTasksType !== 'generally' && dailyTasksType !== 'pending_chat' && dailyTasksType !== 'special_contents' && dailyTasksType !== 'referral_codes'">
          <b-row
            v-for="dailyTaskUser in dailyTasksUsers"
            :key="dailyTaskUser.uuid"
          >
            <b-col
              lg="6"
              cols="12"
            >
              <div class="user-card">
                <div class="profile">
                  <div class="image">
                    <b-avatar
                      size="40"
                      :src="dailyTaskUser.avatar_url"
                      variant="light-primary"
                      class="badge-minimal"
                      :badge="typeof dailyTaskUser.is_connected !== 'undefined' && dailyTaskUser.is_connected"
                      :badge-variant="typeof dailyTaskUser.is_connected !== 'undefined' && dailyTaskUser.is_connected ? 'success' : 'danger'"
                    >
                      <feather-icon
                        v-if="!dailyTaskUser.avatar_url"
                        icon="UserIcon"
                        size="22"
                      />
                    </b-avatar>
                  </div>
                  <div class="username-country">
                    <p class="username">
                      {{ dailyTaskUser.user_name }}
                      <b-img
                        v-if="dailyTaskUser.user_country && getImageFromCountry(dailyTaskUser.user_country)"
                        :src="getImageFromCountry(dailyTaskUser.user_country)"
                        width="32"
                        :alt="dailyTaskUser.user_name"
                      />
                      <span v-else>
                        {{ dailyTaskUser.user_country ? `,${$t('countries.' + dailyTaskUser.user_country)}` : '' }}
                      </span>
                    </p>
                  </div>
                </div>
                <div class="actions">
                  <div
                    v-if="false && !dailyTaskUser.is_vip && !canStartVideoCall"
                    class="video-call"
                  >
                    <b-img
                      :src="iconCall"
                      height="18"
                      width="18"
                      @click="call(dailyTaskUser, i)"
                    />
                  </div>
                  <div
                    v-if="false && ((dailyTaskUser.camera_on && dailyTaskUser.is_vip && userCanStartVideoCall) || (dailyTaskUser.camera_on && dailyTaskUser.user_country !== 'TR' && canStartVideoCall && userCanStartVideoCall))"
                    class="video-call"
                  >
                    <b-img
                      :src="iconVideoCall"
                      height="18"
                      width="18"
                      @click="videoCall(dailyTaskUser, i)"
                    />
                  </div>
                  <div class="video-call">
                    <b-img
                      :src="iconChat"
                      height="18"
                      width="18"
                      @click="chat(dailyTaskUser, i)"
                    />
                  </div>
                </div>
                <div
                  v-if="dailyTaskUser.step_expire"
                  class="user-card-timer"
                >
                  <div>
                    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20.4688 10.4062C20.4688 13.0501 19.4185 15.5857 17.549 17.4552C15.6795 19.3247 13.1439 20.375 10.5 20.375C7.85612 20.375 5.32053 19.3247 3.45103 17.4552C1.58153 15.5857 0.53125 13.0501 0.53125 10.4062C0.53125 7.76237 1.58153 5.22678 3.45103 3.35728C5.32053 1.48778 7.85612 0.4375 10.5 0.4375C13.1439 0.4375 15.6795 1.48778 17.549 3.35728C19.4185 5.22678 20.4688 7.76237 20.4688 10.4062Z" fill="url(#paint0_linear_1866_10182)"/>
                      <path d="M18.6562 10.4062C18.6562 12.5694 17.7969 14.644 16.2673 16.1736C14.7377 17.7032 12.6632 18.5625 10.5 18.5625C8.33683 18.5625 6.26225 17.7032 4.73266 16.1736C3.20307 14.644 2.34375 12.5694 2.34375 10.4062C2.34375 8.24308 3.20307 6.1685 4.73266 4.63891C6.26225 3.10932 8.33683 2.25 10.5 2.25C12.6632 2.25 14.7377 3.10932 16.2673 4.63891C17.7969 6.1685 18.6562 8.24308 18.6562 10.4062Z" fill="url(#paint1_linear_1866_10182)"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.59375 4.96875C9.8341 4.96875 10.0646 5.06423 10.2346 5.23418C10.4045 5.40414 10.5 5.63465 10.5 5.875V10.4062H13.2188C13.4591 10.4062 13.6896 10.5017 13.8596 10.6717C14.0295 10.8416 14.125 11.0721 14.125 11.3125C14.125 11.5529 14.0295 11.7834 13.8596 11.9533C13.6896 12.1233 13.4591 12.2188 13.2188 12.2188H9.59375C9.3534 12.2188 9.12289 12.1233 8.95293 11.9533C8.78298 11.7834 8.6875 11.5529 8.6875 11.3125V5.875C8.6875 5.63465 8.78298 5.40414 8.95293 5.23418C9.12289 5.06423 9.3534 4.96875 9.59375 4.96875Z" fill="url(#paint2_linear_1866_10182)"/>
                      <defs>
                        <linearGradient id="paint0_linear_1866_10182" x1="3.85356" y1="-0.669937" x2="13.8223" y2="21.4824" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#00FFE7"/>
                          <stop offset="1" stop-color="#0FE08D"/>
                        </linearGradient>
                        <linearGradient id="paint1_linear_1866_10182" x1="4.82688" y1="0.477375" x2="15.4644" y2="23.1717" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#FDFDFD"/>
                          <stop offset="1" stop-color="#DEDEFF"/>
                        </linearGradient>
                        <linearGradient id="paint2_linear_1866_10182" x1="11.225" y1="4.82737" x2="14.6434" y2="10.5259" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#00EED7"/>
                          <stop offset="1" stop-color="#10E08E"/>
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <div>
                    {{ getRemainingTime(dailyTaskUser.step_expire, dailyTaskUser.uuid) }}
                  </div>
                </div>
              </div>
              <div class="user-card-bottom">
                <div class="user-card-bottom-levels">
                  <div class="progress-tracker-container">
                    <div class="steps-wrapper">
                      <!-- Her bir adımı v-for ile oluşturuyoruz -->
                      <div
                        v-for="(step, index) in taskSteps"
                        :key="index"
                        class="step-item"
                      >
                        <!-- Adım grafiği (çizgi ve daire) -->
                        <div class="step-graphic">
                          <div
                            class="line"
                            :class="{
                              'invisible': index === 0,
                              'gray-line': (index === 1 && !dailyTaskUser.step2) || (index === 2 && !dailyTaskUser.step3) || (index === 3 && !dailyTaskUser.step4)
                            }"
                          />
                          <div
                            class="circle"
                            :class="{
                              'gray-circle': (index === 0 && !dailyTaskUser.step1) || (index === 1 && !dailyTaskUser.step2) || (index === 2 && !dailyTaskUser.step3) || (index === 3 && !dailyTaskUser.step4),
                            }"
                          >
                            <!-- Onay işareti için SVG ikon -->
                            <svg
                              v-if="(index === 0 && dailyTaskUser.step1) || (index === 1 && dailyTaskUser.step2) || (index === 2 && dailyTaskUser.step3) || (index === 3 && dailyTaskUser.step4)"
                              id="step1" class="check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                              <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                              <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                            </svg>
                          </div>
                          <div
                            class="line"
                            :class="{
                              'invisible': index === taskSteps.length - 1,
                              'gray-line': (index === 0 && !dailyTaskUser.step2) || (index === 1 && !dailyTaskUser.step3) || (index === 2 && !dailyTaskUser.step4)
                            }"
                          />
                        </div>

                        <!-- Adım bilgileri (başlık ve ödül) -->
                        <div class="step-info">
                          <div class="step-title">
                            {{ step.title }}
                          </div>
                          <div v-if="step.rewardAmount" class="step-reward">
                            <span>
                              {{ step.rewardAmount }}
                            </span>
                            <span>
                              {{ step.rewardCurrency }}
                            </span>
                            <b-img
                              src="@/assets/images/icons/bean.png"
                              width="12"
                            />
                          </div>
                          <div v-else class="step-reward">
                            -
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="user-card-bottom-description" v-html="dailyTaskUserDescription"></div>
              </div>
            </b-col>
          </b-row>
        </div>
        <!-- Kullanıcı listesi boş (generally, pending_chat) -->
        <div :key="`empty-users-${dailyTasksType}`" v-if="(dailyTasksType === 'generally' || dailyTasksType === 'pending_chat') && (!dailyTasksUsers || dailyTasksUsers.length === 0) && !loading">
          <div class="no-data-container">
            <h4 class="no-data-title">{{ $t('Looks like no one\'s eligible here right now!') }}</h4>
            <div class="no-data-description">{{ $t('Take a peek at other tabs — someone new might be waiting there!') }}</div>
          </div>
        </div>

        <div :key="`empty-tasks-${dailyTasksType}`" v-if="memberTabs.length > 0 && (!dailyTasksUsers || (Array.isArray(dailyTasksUsers) && dailyTasksUsers.length < 1)) && dailyTasksType !== 'general' && dailyTasksType !== 'generally' && dailyTasksType !== 'pending_chat' && dailyTasksType !== 'special_contents' && dailyTasksType !== 'referral_codes'">
          <b-row>
            <b-col
              lg="6"
              cols="12"
            >
              <div class="no-data-container">
                <div v-if="!loading">
                  <h4 class="no-data-title">
                    {{ $t('Looks like no one’s eligible here right now!') }}
                  </h4>
                  <div class="no-data-description">
                    {{ $t('Take a peek at other tabs — someone new might be waiting there!') }}
                  </div>
                </div>
                <h4
                  v-else
                  class="no-data-title"
                >
                  {{ $t('Loading') }}...
                </h4>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-row v-if="dailyTasksType && dailyTasksType === 'general'" class="align-items-stretch">
          <b-col
            v-if="dataMissionsConnectedTime"
            class="d-flex"
            lg="12"
            cols="12"
          >
            <b-card class="w-100">
              <b-card-title class="p-1 d-flex justify-content-between align-items-center">
                <h5>
                  {{ `${dataMissionsConnectedTime.title || ''} ${$t('sec.')}` }}
                </h5>
              </b-card-title>
              <div class="chart-container">
                <v-chart
                  v-if="dataMissionsConnectedTime"
                  ref="myChart"
                  :options="chartOptions"
                  style="height: 100%; width: 100%;"
                />
              </div>
              <div>
                <h5>
                  {{ dataMissionsConnectedTime.description }}
                </h5>
              </div>
            </b-card>
          </b-col>
          <b-col
            v-if="dataMissionsCollectedBeans"
            class="d-flex"
            lg="6"
            cols="12"
          >
            <b-card class="w-100">
              <h6 class="text-right">
                {{ $t('Earn') }}: {{ dataMissionsCollectedBeans.earn }}
                <b-img
                  src="@/assets/images/icons/bean.png"
                  width="16"
                />
              </h6>
              <h6 class="mb-2">
                {{ dataMissionsCollectedBeans.title }}
              </h6>
              <div class="reward-progress">
                <b-img
                  src="@/assets/images/icons/bean.png"
                  width="36"
                  class="reward-progress-bean"
                />
                <b-progress
                  variant="success"
                  :max="dataMissionsCollectedBeans.target"
                  animated
                  striped
                  height="2rem"
                >
                  <b-progress-bar :value="dataMissionsCollectedBeans.completed">
                    <div class="reward-progress-bar">
                      {{ numberFormatter(dataMissionsCollectedBeans.completed) }} / {{ numberFormatter(dataMissionsCollectedBeans.target) }}
                    </div>
                  </b-progress-bar>
                </b-progress>
              </div>
            </b-card>
          </b-col>
          <b-col
            v-if="dataMissionsCollectedBeansVoice"
            class="d-flex"
            lg="6"
            cols="12"
          >
            <b-card class="w-100">
              <h6 class="text-right">
                {{ $t('Earn') }}: {{ dataMissionsCollectedBeansVoice.earn }}
                <b-img
                  src="@/assets/images/icons/bean.png"
                  width="16"
                />
              </h6>
              <h6 class="mb-2">
                {{ dataMissionsCollectedBeansVoice.title }}
              </h6>
              <div class="reward-progress">
                <b-img
                  src="@/assets/images/icons/bean.png"
                  width="36"
                  class="reward-progress-bean"
                />
                <b-progress
                  variant="success"
                  :max="dataMissionsCollectedBeansVoice.target"
                  animated
                  striped
                  height="2rem"
                >
                  <b-progress-bar :value="dataMissionsCollectedBeansVoice.completed">
                    <div class="reward-progress-bar">
                      {{ Math.round((dataMissionsCollectedBeansVoice.completed / dataMissionsCollectedBeansVoice.target) * 100) }}%
                    </div>
                  </b-progress-bar>
                </b-progress>
              </div>
            </b-card>
          </b-col>
          <b-col
            v-if="dataMissionsCollectedBeansVideo"
            class="d-flex"
            lg="6"
            cols="12"
          >
            <b-card class="w-100">
              <h6 class="text-right">
                {{ $t('Earn') }}: {{ dataMissionsCollectedBeansVideo.earn }}
                <b-img
                  src="@/assets/images/icons/bean.png"
                  width="16"
                />
              </h6>
              <h6 class="mb-2">
                {{ dataMissionsCollectedBeansVideo.title }}
              </h6>
              <div class="reward-progress">
                <b-img
                  src="@/assets/images/icons/bean.png"
                  width="36"
                  class="reward-progress-bean"
                />
                <b-progress
                  variant="success"
                  :max="dataMissionsCollectedBeansVideo.target"
                  animated
                  striped
                  height="2rem"
                >
                  <b-progress-bar :value="dataMissionsCollectedBeansVideo.completed">
                    <div class="reward-progress-bar">
                      {{ Math.round((dataMissionsCollectedBeansVideo.completed / dataMissionsCollectedBeansVideo.target) * 100) }}%
                    </div>
                  </b-progress-bar>
                </b-progress>
              </div>
            </b-card>
          </b-col>
          <b-col
            v-if="dataMissionsMomentMessageTime && (Number(dataMissionsMomentMessageTime.message_target) > 0 || Number(dataMissionsMomentMessageTime.moment_target) > 0)"
            class="d-flex"
            lg="6"
            cols="12"
          >
            <b-card class="w-100">
              <h6 class="text-right">
                {{ $t('Earn') }}: {{ dataMissionsMomentMessageTime.earn }}
                <b-img
                  src="@/assets/images/icons/bean.png"
                  width="16"
                />
              </h6>
              <h6 class="mb-2">
                {{ dataMissionsMomentMessageTime.title }}
              </h6>
              <div class="d-flex justify-content-between">
              <div
                v-if="Number(dataMissionsMomentMessageTime.message_target) > 0"
                class="reward-progress"
                style="width: 65%"
              >
                  <b-img
                    src="@/assets/images/icons/bean.png"
                    width="36"
                    class="reward-progress-bean"
                  />
                  <b-progress
                    variant="success"
                    :max="dataMissionsMomentMessageTime.message_target"
                    show-value
                    animated
                    striped
                    height="2rem"
                  >
                    <b-progress-bar :value="dataMissionsMomentMessageTime.message_completed">
                      <div class="reward-progress-bar">
                        {{ numberFormatter(dataMissionsMomentMessageTime.message_completed) }} / {{ numberFormatter(dataMissionsMomentMessageTime.message_target) }}
                      </div>
                    </b-progress-bar>
                  </b-progress>
                </div>
              <div
                v-if="Number(dataMissionsMomentMessageTime.moment_target) > 0"
                class="reward-progress"
                :style="{ width: Number(dataMissionsMomentMessageTime.message_target) > 0 ? '30%' : '100%' }"
              >
                  <b-progress
                    variant="success"
                    :max="dataMissionsMomentMessageTime.moment_target"
                    show-value
                    animated
                    striped
                    height="2rem"
                  >
                    <b-progress-bar :value="dataMissionsMomentMessageTime.moment_completed">
                      <div class="reward-progress-bar">
                        {{ numberFormatter(dataMissionsMomentMessageTime.moment_completed) }} / {{ numberFormatter(dataMissionsMomentMessageTime.moment_target) }}
                      </div>
                    </b-progress-bar>
                  </b-progress>
                </div>
              </div>
            </b-card>
          </b-col>
          <b-col
            v-if="dataMissionsProfilePhoto"
            class="d-flex"
            lg="6"
            cols="12"
          >
            <b-card class="w-100">
              <div class="d-flex justify-content-between">
                <h6 class="text-right">
                  {{ $t('Remaining') }}: {{ dataMissionsProfilePhoto.remaining }} |
                  {{ $t('Target') }}: {{ dataMissionsProfilePhoto.target }}
                </h6>
                <h6>
                  {{ $t('Earn') }}: {{ dataMissionsProfilePhoto.earn }}
                  <b-img
                    src="@/assets/images/icons/bean.png"
                    width="16"
                  />
                </h6>
              </div>
              <h6 class="mb-2">
                {{ dataMissionsProfilePhoto.title }}
              </h6>
              <div class="reward-progress">
                <b-img
                  src="@/assets/images/icons/bean.png"
                  width="36"
                  class="reward-progress-bean"
                />
                <b-progress
                  variant="success"
                  :max="dataMissionsProfilePhoto.target"
                  animated
                  striped
                  height="2rem"
                >
                  <b-progress-bar :value="dataMissionsProfilePhoto.completed">
                    <div class="reward-progress-bar">
                      {{ Math.round((dataMissionsProfilePhoto.completed / dataMissionsProfilePhoto.target) * 100) }}%
                    </div>
                  </b-progress-bar>
                </b-progress>
              </div>
            </b-card>
          </b-col>
          <b-col
            v-if="dataDefinedHoursConnected"
            class="d-flex"
            lg="6"
            cols="12"
          >
            <b-card class="w-100">
              <div class="d-flex justify-content-between">
                <h6 v-if="false" class="text-right">
                  {{ $t('Remaining') }}: {{ numberFormatter(dataDefinedHoursConnected.remaining) }} {{ $t('sec.') }} |
                  {{ $t('Target') }}: {{ numberFormatter(dataDefinedHoursConnected.target) }} {{ $t('sec.') }}
                </h6>
                <div v-else />
                <h6>
                  {{ $t('Earn') }}: {{ numberFormatter(dataDefinedHoursConnected.earn) }}
                  <b-img
                    src="@/assets/images/icons/bean.png"
                    width="16"
                  />
                </h6>
              </div>
              <h6 class="mb-2">
                {{ dataDefinedHoursConnected.title }}
              </h6>
              <div v-if="dataDefinedHoursConnected.beans_target > 0" class="reward-progress mt-1">
                <b-img
                  src="@/assets/images/icons/bean.png"
                  width="32"
                  class="reward-progress-bean"
                />
                <b-progress
                  variant="success"
                  :max="dataDefinedHoursConnected.beans_target"
                  animated
                  striped
                  height="2rem"
                >
                  <b-progress-bar :value="dataDefinedHoursConnected.beans_completed">
                    <div class="reward-progress-bar">
                      {{ dataDefinedHoursConnected.beans_completed }} / {{ dataDefinedHoursConnected.beans_target }}
                    </div>
                  </b-progress-bar>
                </b-progress>
              </div>
              <div v-if="Number(dataDefinedHoursConnected.moment_target) > 0" class="reward-progress mt-1">
                <div class="reward-progress-icon">
                  <feather-icon
                    icon="ActivityIcon"
                    size="20"
                  />
                </div>
                <b-progress
                  variant="success"
                  :max="dataDefinedHoursConnected.moment_target"
                  animated
                  striped
                  height="2rem"
                >
                  <b-progress-bar :value="dataDefinedHoursConnected.moment_completed">
                    <div class="reward-progress-bar">
                      {{ numberFormatter(dataDefinedHoursConnected.moment_completed) }} / {{ numberFormatter(dataDefinedHoursConnected.moment_target) }}
                    </div>
                  </b-progress-bar>
                </b-progress>
              </div>
              <div class="reward-progress">
                <b-img
                  src="@/assets/images/icons/clock.png"
                  width="36"
                  class="reward-progress-bean"
                />
                <b-progress
                  variant="success"
                  :max="dataDefinedHoursConnected.target"
                  animated
                  striped
                  height="2rem"
                >
                  <b-progress-bar :value="dataDefinedHoursConnected.completed">
                    <div class="reward-progress-bar">
                      {{ numberFormatter(parseInt(dataDefinedHoursConnected.completed / 60)) }} / {{ numberFormatter(parseInt(dataDefinedHoursConnected.target / 60)) }} {{ $t('minutes') }}
                    </div>
                  </b-progress-bar>
                </b-progress>
              </div>
            </b-card>
          </b-col>
          <b-col
            v-if="dataMissionsCallCount"
            class="d-flex"
            lg="6"
            cols="12"
          >
            <b-card class="w-100">
              <div style="display: flex; justify-content: space-between">
                <h6>
                  {{ dataMissionsCallCount.title }}
                </h6>
                <h6 class="text-right">
                  {{ $t('Earn') }}: {{ dataMissionsCallCount.earn }}
                  <b-img
                    src="@/assets/images/icons/bean.png"
                    width="16"
                  />
                </h6>
              </div>
              <h6 class="mb-2">
                {{ dataMissionsCallCount.description }}
              </h6>
              <div class="d-flex justify-content-between">
                <div
                  class="reward-progress"
                  style="width: 65%"
                >
                  <b-img
                    src="@/assets/images/icons/bean.png"
                    width="36"
                    class="reward-progress-bean"
                  />
                  <b-progress
                    :max="dataMissionsCallCount.min_user_target"
                    show-value
                    animated
                    striped
                    height="2rem"
                  >
                    <b-progress-bar :value="dataMissionsCallCount.min_user_completed">
                      <div class="reward-progress-bar">
                        {{ numberFormatter(dataMissionsCallCount.min_user_completed) }} / {{ numberFormatter(dataMissionsCallCount.min_user_target) }}
                      </div>
                    </b-progress-bar>
                  </b-progress>
                </div>
                <div
                  class="reward-progress"
                  style="width: 30%"
                >
                  <b-progress
                    :max="dataMissionsCallCount.min_credit_target"
                    show-value
                    animated
                    striped
                    height="2rem"
                  >
                    <b-progress-bar :value="dataMissionsCallCount.min_credit_completed">
                      <div class="reward-progress-bar">
                        {{ numberFormatter(dataMissionsCallCount.min_credit_completed) }} / {{ numberFormatter(dataMissionsCallCount.min_credit_target) }}
                      </div>
                    </b-progress-bar>
                  </b-progress>
                </div>
              </div>
            </b-card>
          </b-col>
          <b-col
            v-if="dataMissionsNdc"
            class="d-flex"
            lg="6"
            cols="12"
          >
            <b-card class="w-100">
              <h6 class="text-right">
                {{ $t('Earn') }}: {{ dataMissionsNdc.earn }}
                <b-img
                  src="@/assets/images/icons/bean.png"
                  width="16"
                />
              </h6>
              <h6 class="mb-2">
                {{ dataMissionsNdc.title }}
              </h6>
            </b-card>
          </b-col>
          <b-col
            v-if="dataMissionsOutcall"
            class="d-flex mb-3"
            lg="6"
            cols="12"
          >
            <b-card class="w-100">
              <h6
                v-if="dataMissionsOutcall.earn"
                class="text-right"
              >
                {{ $t('Earn') }}: {{ dataMissionsOutcall.earn }}
                <b-img
                  src="@/assets/images/icons/bean.png"
                  width="16"
                />
              </h6>
              <h6 class="my-2">
                {{ dataMissionsOutcall.title }}
              </h6>
            </b-card>
          </b-col>
          <b-col
            v-if="dataDailySendMessage"
            class="d-flex"
            lg="6"
            cols="12"
          >
            <b-card class="w-100">
              <div style="display: flex; justify-content: space-between">
                <h6>
                  {{ dataDailySendMessage.title }}
                </h6>
                <h6 class="text-right">
                  {{ $t('Earn') }}: {{ dataDailySendMessage.earn }}
                  <b-img
                    src="@/assets/images/icons/bean.png"
                    width="16"
                  />
                </h6>
              </div>
              <h6 class="mb-2">
                {{ dataDailySendMessage.description }}
              </h6>
              <div class="d-flex justify-content-between">
                <div
                  class="reward-progress"
                  style="width: 65%"
                >
                  <b-img
                    src="@/assets/images/icons/bean.png"
                    width="36"
                    class="reward-progress-bean"
                  />
                  <b-progress
                    variant="success"
                    :max="dataDailySendMessage.send_message_target"
                    animated
                    striped
                    height="2rem"
                  >
                    <b-progress-bar :value="dataDailySendMessage.send_message_count">
                      <div class="reward-progress-bar">
                        {{ dataDailySendMessage.send_message_count }} / {{ dataDailySendMessage.send_message_target }}
                      </div>
                    </b-progress-bar>
                  </b-progress>
                </div>
                <div
                  class="reward-progress"
                  style="width: 30%"
                >
                  <b-progress
                    variant="success"
                    :max="dataDailySendMessage.mutual_target"
                    animated
                    striped
                    height="2rem"
                  >
                    <b-progress-bar :value="dataDailySendMessage.mutual_count">
                      <div class="reward-progress-bar">
                        {{ dataDailySendMessage.mutual_count }} / {{ dataDailySendMessage.mutual_target }}
                      </div>
                    </b-progress-bar>
                  </b-progress>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </section>
</template>

<script>
import {
  BAvatar,
  BCard,
  BCardTitle,
  BCol,
  BContainer,
  BImg,
  BOverlay,
  BProgress,
  BProgressBar,
  BRow,
} from 'bootstrap-vue'
// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import SpecialContentsManager from './SpecialContents.vue'
import ReferralCodes from './ReferralCodes.vue'
import { throwDefaultError, numberFormatter } from '@/helpers/helpers'
import moment from 'moment'
import _ from 'lodash'

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'

const notificationsBg = require('@/assets/images/bg/rewards-notification-bg-2.png')

const iconCall = require('@/assets/images/icons/call2.svg')
const iconChat = require('@/assets/images/icons/chat-6.svg')
const iconVideoCall = require('@/assets/images/icons/camera.svg')

export default {
  name: 'RewardsComponent',
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SpecialContentsManager,
    ReferralCodes,
    BAvatar,
    BCard,
    BCardTitle,
    BCol,
    BContainer,
    BImg,
    BOverlay,
    BProgress,
    BProgressBar,
    BRow,

    'v-chart': ECharts,
  },
  data() {
    return {
      activeMissions: null,
      callSource: 'call-task-list',
      canStartVideoCall: false,
      dailyTasksUsers: null,
      dailyTasksRequestId: 0,
      dailyTasksType: '', // bohemian, boho_club_member, new_member
      dataMissionsActive: null,
      dataMissionsOutcall: null,
      dataMissionsCollectedBeans: null,
      dataMissionsProfilePhoto: null,
      dataMissionsCollectedBeansVideo: null,
      dataMissionsCollectedBeansVoice: null,
      dataMissionsConnectedTime: null,
      dataMissionsMomentMessageTime: null,
      dataMissionsCallCount: null,
      dataMissionsNdc: null,
      dataMissionsWelcomeBeans: null,
      dataDefinedHoursConnected: null,
      dataDailySendMessage: null,
      inactiveReason: null,
      date: moment().format('YYYY-MM-DD'),
      iconCall,
      iconChat,
      iconVideoCall,
      incentiveDailyNewTask: null,
      loading: false,
      memberTabs: [
        // { key: 'bohemian', label: 'Bohemian' },
        // { key: 'boho_club_member', label: 'Boho Club Member' },
        // { key: 'hot_users', label: 'Hot Users' },
        // { key: 'new_member', label: 'New Member' },
        // { key: 'in_progress', label: this.$t('In progress') },
      ],
      missions: [],
      notificationsBg,
      showBonusCampaignLink: false,
      showBonusOutcallLink: false,
      showCallTaskListLink: false,
      specialContentAvailable: false,
      remainingTimes: {}, // Her kullanıcı için kalan süre
      updateInterval: null,
      userListOffset: 0,
      userListLimit: 20,
      userListHasMore: true,
      userListLoadingMore: false,
      userListObserver: null,
    }
  },
  computed: {
    displayMemberTabs() {
      const tabs = this.memberTabs.concat([{ key: 'referral_codes', label: this.$t('referrals.tab') }])
      if (!this.specialContentAvailable) return tabs
      return tabs.concat([{ key: 'special_contents', label: this.$t('specialContents.tab') }])
    },
    chartOptions() {
      const data = this.dataMissionsConnectedTime && Array.isArray(this.dataMissionsConnectedTime.data)
        ? this.dataMissionsConnectedTime.data.map(d => parseInt(d.completed))
        : []
      const max = Math.max(...data) * 1.2

      console.log('data', data)

      return {
        xAxis: {
          type: 'category',
          data: [
            this.$t('Mon.'),
            this.$t('Tue.'),
            this.$t('Wed.'),
            this.$t('Thu.'),
            this.$t('Fri.'),
            this.$t('Sat.'),
            this.$t('Sun.'),
          ],
          axisLabel: {
            fontSize: 11,
            interval: 0,
            rotate: 0,
            color: 'rgba(226, 220, 255, 0.72)',
            fontWeight: 600,
            margin: 12,
          },
          axisLine: {
            lineStyle: { color: 'rgba(170, 140, 255, 0.25)' },
          },
          axisTick: { show: false },
        },
        yAxis: {
          show: false,
          max,
        },
        grid: {
          left: 10,
          right: 10,
          top: 34,
          bottom: 30,
        },
        series: [
          {
            name: `${this.dataMissionsConnectedTime.title || ''} ${this.$t('sec.')}`,
            type: 'bar',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(150, 110, 255, 0.12)',
              barBorderRadius: [12, 12, 12, 12],
            },
            barMaxWidth: 34,
            datasetIndex: 1,
            data,
            itemStyle: {
              // Boho gradyanı: pembe → mor
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: '#ea03b2' },
                  { offset: 1, color: '#a855f7' },
                ],
              },
              barBorderRadius: [12, 12, 12, 12],
              shadowColor: 'rgba(234, 3, 178, 0.35)',
              shadowBlur: 10,
            },
            emphasis: {
              itemStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: '#f472b6' },
                    { offset: 1, color: '#c084fc' },
                  ],
                },
              },
            },
            label: {
              show: true,
              position: 'top',
              formatter: params => this.formatTime(params.value),
              color: '#ffffff',
              fontSize: 11,
              fontWeight: 700,
              padding: [2, 5],
            },
          },
        ],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            shadowStyle: { color: 'rgba(168, 85, 247, 0.12)' },
          },
          backgroundColor: 'rgba(29, 18, 71, 0.95)',
          borderColor: 'rgba(234, 3, 178, 0.45)',
          borderWidth: 1,
          padding: [8, 12],
          textStyle: { color: '#f4f1ff', fontSize: 12 },
          extraCssText: 'border-radius: 12px; box-shadow: 0 10px 24px rgba(6, 2, 24, 0.45);',
          formatter: params => {
            const param = params[0]
            return `
              <div style="text-align: center;">
                <strong>${param.axisValue}</strong><br />
                ${this.formatTime(param.value, true)}
              </div>
            `
          },
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100,
          },
        ],
      }
    },
    dailyTaskUserDescription() {
      // eslint-disable-next-line global-require
      const beanIcon = require('@/assets/images/icons/bean.png')
      return this.$t('dailyTaskUserDescription', {
        bean: `<img src="${beanIcon}" width="12" />`,
      })
    },
    notification() {
      return {
        title: this.$t('rewards.notification.title'),
        text: this.$t('rewards.notification.text'),
      }
    },
    taskSteps() {
      return [
        {
          title: this.$t('Send message'),
          rewardAmount: null,
          rewardCurrency: this.$t('Beans'),
        },
        {
          title: this.$t('Receive message'),
          rewardAmount: '75',
          rewardCurrency: this.$t('Beans'),
        },
        // {
        //   title: this.$t('Call'),
        //   rewardAmount: null,
        //   rewardCurrency: this.$t('Beans'),
        // },
        {
          title: this.$t('Receive call'),
          rewardAmount: '1150',
          rewardCurrency: this.$t('Beans'),
        },
      ]
    },
    totalEarn() {
      let totalEarn = 0

      if (this.incentiveDailyNewTask) {
        totalEarn += this.incentiveDailyNewTask.earn || 0
      }

      if (this.dataMissionsCollectedBeansVoice && this.dataMissionsCollectedBeansVoice.remaining <= 0) {
        totalEarn += this.dataMissionsCollectedBeansVoice.earn || 0
      }

      if (this.dataMissionsCollectedBeansVideo && this.dataMissionsCollectedBeansVideo.remaining <= 0) {
        totalEarn += this.dataMissionsCollectedBeansVideo.earn || 0
      }

      return totalEarn
    },
    userGender() {
      return this.$store.getters['auth/userGender']
    },
    userCanStartVideoCall() {
      return this.$store.getters['auth/userCanStartVideoCall']
    },
  },
  watch: {
    activeMissions(value) {
      if (value && Array.isArray(value.active_missions)) {
        this.missions = value.active_missions
        this.getData(value.active_missions)
      }
      if (value) {
        this.inactiveReason = value.inactive_reason || null
      }
    },
    dailyTasksUsers: {
      handler() {
        // Yeni kullanıcılar geldiğinde süreleri güncelle
        this.updateAllRemainingTimes()
      },
      deep: true,
    },
  },
  created() {
    // this.getData()

    // Availability is checked as soon as Rewards mounts so the card can be hidden for ineligible users.
    useJwt.specialContentsAvailability()
      .then(response => {
        const body = response && response.data ? response.data.body : null
        this.specialContentAvailable = !!(body && body.available)
      })
      .catch(() => {
        this.specialContentAvailable = false
      })

    this.getActiveMissions()

    this.getCallTaskListPermitted()

    this.getIncentiveDailyNewTask()

    this.getNewDailyTasks()

    // Interval başlat
    this.startUpdateInterval()

    // Get daily task eligible list
    useJwt.newDailyTasksEligibleList()
      .then(response => {
        const list = Array.isArray(response.data.body.list) ? response.data.body.list : []
        const otherTabs = list
          .filter(key => key !== 'generally')
          .map(key => {
            let label = ''
            if (key === 'bohemian') label = this.$t('Diamond Holder')
            if (key === 'boho_club_member') label = this.$t('First-Time Payer')
            if (key === 'hot_users') label = this.$t('Hot Users')
            if (key === 'new_member') label = this.$t('New Registration')
            if (key === 'in_progress') label = this.$t('In progress')
            return { key, label }
          })
        const selectedExtraTab = ['special_contents', 'referral_codes'].includes(this.dailyTasksType) ? this.dailyTasksType : null
        this.memberTabs = [
          { key: 'general', label: this.$t('Tasks') },
          { key: 'generally', label: this.$t('User List') },
          { key: 'pending_chat', label: this.$t('Pending Chat User List') },
          ...otherTabs,
        ]
        this.dailyTasksType = selectedExtraTab
          ? selectedExtraTab
          : (this.memberTabs.length > 0 ? this.memberTabs[0].key : '')
        this.canStartVideoCall = !!response.data.body.canStartVideoCall
        if (this.dailyTasksType === 'generally') {
          this.getNewDailyTasks()
        }
      })
  },
  mounted() {
    window.addEventListener('resize', this.resizeChart)
    this.setupUserListObserver()

    // Kişinin bilgilerini getir
    useJwt.getMe()
      .then(response => {
        this.$store.dispatch('auth/updateUser', response.data.body)
      })
  },
  updated() {
    this.setupUserListObserver()
  },
  beforeDestroy() {
    this.dailyTasksRequestId += 1
    window.removeEventListener('resize', this.resizeChart)
    this.userListObserver && this.userListObserver.disconnect()

    // Interval'i temizle
    if (this.updateInterval) {
      clearInterval(this.updateInterval)
      this.updateInterval = null
    }
  },
  methods: {
    call(user, i) {
      // eslint-disable-next-line no-underscore-dangle
      const _user = {
        ...user,
        userName: user.user_name,
        profile: {
          image: user.avatar_url,
        },
        id: user.uuid,
      }

      if (this.mobile) {
        if (window.webkit) {
          if (window.webkit.messageHandlers && window.webkit.messageHandlers.iosListener) {
            // eslint-disable-next-line radix
            window.webkit.messageHandlers.iosListener.postMessage({
              key: 'call-user',
              user: _user,
              order: parseInt(i),
              callSource: 'call-task-list',
            })
          }
        }
        if (window.AndroidApp) {
          // eslint-disable-next-line radix
          window.AndroidApp.sendData(JSON.stringify({
            key: 'call-user',
            user: _user,
            order: parseInt(i),
            title: this.$t('Call Task List'),
            callSource: 'call-task-list',
          }))
        }
      } else {
        this.$store.dispatch('app/setModalCallType', 'audio')
        this.$store.dispatch('app/setCallDetails', {
          callSource: this.callSource,
          userOrder: i,
        })
        this.$store.dispatch('app/setModalCall', false)
        setTimeout(() => {
          this.$store.dispatch('app/setModalCallUser', _user)
          this.$store.dispatch('app/setModalCall', true)
        }, 33)
      }
    },
    chat(user, i) {
      const _user = {
        ...user,
        userName: user.user_name,
        profile: {
          image: user.avatar_url,
        },
        id: user.uuid,
      }

      if (this.mobile) {
        if (window.webkit) {
          if (window.webkit.messageHandlers && window.webkit.messageHandlers.iosListener) {
            // eslint-disable-next-line radix
            window.webkit.messageHandlers.iosListener.postMessage({
              key: 'chat-user',
              user: _user,
              order: parseInt(i),
              callSource: 'call-task-list',
            })
          }
        }
        if (window.AndroidApp) {
          // eslint-disable-next-line radix
          window.AndroidApp.sendData(JSON.stringify({
            key: 'chat-user',
            user: _user,
            order: parseInt(i),
            title: this.$t('Call Task List'),
            callSource: 'call-task-list',
          }))
        }
      } else {
        this.$router.push({
          name: 'chat',
          params: {
            userId: user.uuid,
          },
        })
      }
    },
    videoCall(user, i) {
      const _user = {
        ...user,
        userName: user.user_name,
        profile: {
          image: user.avatar_url,
        },
        id: user.uuid,
      }

      if (this.mobile) {
        if (window.webkit) {
          if (window.webkit.messageHandlers && window.webkit.messageHandlers.iosListener) {
            // eslint-disable-next-line radix
            window.webkit.messageHandlers.iosListener.postMessage({
              key: 'video-call-user',
              user: _user,
              order: parseInt(i),
              callSource: 'call-task-list',
            })
          }
        }
        if (window.AndroidApp) {
          // eslint-disable-next-line radix
          window.AndroidApp.sendData(JSON.stringify({
            key: 'video-call-user',
            user: _user,
            order: parseInt(i),
            title: this.$t('Call Task List'),
            callSource: 'call-task-list',
          }))
        }
      } else {
        this.$store.dispatch('app/setModalCallType', 'video')
        this.$store.dispatch('app/setCallDetails', {
          callSource: this.callSource,
          userOrder: i,
        })
        this.$store.dispatch('app/setModalCall', false)
        setTimeout(() => {
          this.$store.dispatch('app/setModalCallUser', _user)
          this.$store.dispatch('app/setModalCall', true)
        }, 33)
      }
    },
    numberFormatter,
    changeMemberType(type) {
      this.dailyTasksRequestId += 1
      this.dailyTasksType = type
      this.dailyTasks = null
      this.dailyTasksUsers = null
      this.userListLoadingMore = false
      this.userListHasMore = true
      this.loading = false
      if (this.userListObserver) this.userListObserver.disconnect()
      if (type === 'special_contents' || type === 'referral_codes') return
      if (type === 'generally') {
        this.getNewDailyTasksUserList(false)
      } else if (type === 'pending_chat') {
        this.getNewDailyTasksPendingChatList(false)
      } else if (type && type !== 'general') {
        this.getNewDailyTasks()
      }
    },
    getActiveMissions() {
      this.loading = true

      useJwt.missionsActive()
        .then(response => {
          this.activeMissions = response.data.body
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getImageFromCountry(country) {
      try {
        return require(`@/assets/images/flags2/${country}.svg`)
      } catch (error) {
        return null
      }
    },
    getIncentiveDailyNewTask() {
      this.loading = true

      useJwt.incentiveDailyNewTask(this.date)
        .then(response => {
          this.incentiveDailyNewTask = response.data.body
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getNewDailyTasks() {
      const requestId = ++this.dailyTasksRequestId
      this.loading = true

      if (this.dailyTasksType === 'in_progress') {
        useJwt.newDailyTasksProcessUsers()
          .then(response => {
            if (requestId !== this.dailyTasksRequestId) return
            this.dailyTasksUsers = response.data.body || []
          })
          .catch(error => {
            if (requestId !== this.dailyTasksRequestId) return
            throwDefaultError(this.$toast, error)
          })
          .finally(() => {
            if (requestId !== this.dailyTasksRequestId) return
            this.loading = false
          })
      } else if (this.dailyTasksType === 'generally') {
        this.getNewDailyTasksUserList(false)
      } else if (this.dailyTasksType === 'pending_chat') {
        this.getNewDailyTasksPendingChatList(false)
      } else {
        useJwt.newDailyTasks(this.dailyTasksType)
          .then(response => {
            if (requestId !== this.dailyTasksRequestId) return
            this.dailyTasksUsers = response.data.body || []
          })
          .catch(error => {
            if (requestId !== this.dailyTasksRequestId) return
            throwDefaultError(this.$toast, error)
          })
          .finally(() => {
            if (requestId !== this.dailyTasksRequestId) return
            this.loading = false
          })
      }
    },
    getNewDailyTasksUserList(append = false) {
      if (this.dailyTasksType !== 'generally') return
      if (append && (this.userListLoadingMore || !this.userListHasMore)) return

      const requestId = ++this.dailyTasksRequestId

      const offset = append ? (this.dailyTasksUsers || []).length : 0
      if (!append) {
        this.loading = true
        this.dailyTasksUsers = []
        this.userListHasMore = true
      } else {
        this.userListLoadingMore = true
      }

      useJwt.newDailyTasksList('generally', offset, this.userListLimit)
        .then(response => {
          if (requestId !== this.dailyTasksRequestId) return
          const list = Array.isArray(response.data.body) ? response.data.body : []
          if (append) {
            this.dailyTasksUsers = [...(this.dailyTasksUsers || []), ...list]
          } else {
            this.dailyTasksUsers = list
          }
          this.userListHasMore = list.length >= this.userListLimit
        })
        .catch(error => {
          if (requestId !== this.dailyTasksRequestId) return
          throwDefaultError(this.$toast, error)
        })
        .finally(() => {
          if (requestId !== this.dailyTasksRequestId) return
          this.loading = false
          this.userListLoadingMore = false
        })
    },
    getNewDailyTasksPendingChatList(append = false) {
      if (this.dailyTasksType !== 'pending_chat') return
      if (append && (this.userListLoadingMore || !this.userListHasMore)) return

      const requestId = ++this.dailyTasksRequestId

      const offset = append ? (this.dailyTasksUsers || []).length : 0
      if (!append) {
        this.loading = true
        this.dailyTasksUsers = []
        this.userListHasMore = true
      } else {
        this.userListLoadingMore = true
      }

      useJwt.newDailyTasksPendingChatList(offset, this.userListLimit)
        .then(response => {
          if (requestId !== this.dailyTasksRequestId) return
          const list = Array.isArray(response.data.body) ? response.data.body : []
          if (append) {
            this.dailyTasksUsers = [...(this.dailyTasksUsers || []), ...list]
          } else {
            this.dailyTasksUsers = list
          }
          this.userListHasMore = list.length >= this.userListLimit
        })
        .catch(error => {
          if (requestId !== this.dailyTasksRequestId) return
          throwDefaultError(this.$toast, error)
        })
        .finally(() => {
          if (requestId !== this.dailyTasksRequestId) return
          this.loading = false
          this.userListLoadingMore = false
        })
    },
    activityStatus(user) {
      if (!user) return null
      if (user.is_connected) return { key: 'online', label: this.$t('Online now') }
      if (!user.last_seen_time) return null
      const m = moment.utc(user.last_seen_time).local()
      const now = moment()
      const diffMins = now.diff(m, 'minutes')
      if (diffMins < 60) return { key: 'recent', label: this.$t('Recently active') }
      if (m.isSame(now, 'day')) return { key: 'today', label: this.$t('Active today') }
      if (now.diff(m, 'days') < 7) return { key: 'week', label: this.$t('Active this week') }
      return { key: 'old', label: this.$t('Active recently') }
    },
    setupUserListObserver() {
      if (this.dailyTasksType !== 'generally' && this.dailyTasksType !== 'pending_chat') return
      if (!this.userListHasMore || this.userListLoadingMore) return
      const sentinel = this.$refs.userListSentinel
      if (!sentinel) return

      this.userListObserver && this.userListObserver.disconnect()
      this.userListObserver = new IntersectionObserver(
        entries => {
          if (entries[0]?.isIntersecting) {
            if (this.dailyTasksType === 'generally') this.getNewDailyTasksUserList(true)
            else if (this.dailyTasksType === 'pending_chat') this.getNewDailyTasksPendingChatList(true)
          }
        },
        { root: null, rootMargin: '100px', threshold: 0.1 }
      )
      this.userListObserver.observe(sentinel)
    },
    getCallTaskListPermitted() {
      useJwt.usersCallListPermitted()
        .then(response => {
          this.showCallTaskListLink = !!response.data.body
        })

      useJwt.bonusCampaignCheck()
        .then(response => {
          this.showBonusCampaignLink = !!response.data.body
        })

      useJwt.bonusOutcallCheck()
        .then(response => {
          this.showBonusOutcallLink = !!response.data.body
        })
    },
    getData(missions = []) {
      this.loading = true
      // const requestMissionsActive = useJwt.missionsActive()
      // const requestMissionsCollectedBeans = useJwt.missionsCollectedBeans(this.date)
      // const requestMissionsConnectedTime = useJwt.missionsConnectedTime(this.date)
      // const requestMissionsMomentMessageTime = useJwt.missionsMomentMessageTime(this.date)
      // const requestMissionsCallCount = useJwt.missionsCallCount(this.date)
      // const requestMissionsNdc = useJwt.missionsNdc(this.date)

      const requests = missions.map(mission => useJwt.missions(mission, this.date))

      Promise.all(requests)
        .then(values => {
          // this.dataMissionsActive = values[0].data.body
          // this.dataMissionsCollectedBeans = values[1].data.body
          // this.dataMissionsConnectedTime = values[2].data.body
          // this.dataMissionsMomentMessageTime = values[3].data.body
          // this.dataMissionsCallCount = values[4].data.body
          // this.dataMissionsNdc = values[5].data.body

          values.forEach((value, index) => {
            if (value.data.body.status) {
              if (this.missions[index] === 'connected-time') {
                this.dataMissionsConnectedTime = value.data.body
              } else if (this.missions[index] === 'moments-message-count') {
                this.dataMissionsMomentMessageTime = value.data.body
              } else if (this.missions[index] === 'call-count') {
                this.dataMissionsCallCount = value.data.body
              } else if (this.missions[index] === 'ndc') {
                this.dataMissionsNdc = value.data.body
              } else if (this.missions[index] === 'daily-video-call-beans') {
                this.dataMissionsCollectedBeansVideo = value.data.body
              } else if (this.missions[index] === 'daily-voice-call-beans') {
                this.dataMissionsCollectedBeansVoice = value.data.body
              } else if (this.missions[index] === 'outcall') {
                this.dataMissionsOutcall = value.data.body
              } else if (this.missions[index] === 'profil-photo-tasks') {
                this.dataMissionsProfilePhoto = value.data.body
              } else if (this.missions[index] === 'defined-hours-connected-incentive') {
                this.dataDefinedHoursConnected = value.data.body
              } else if (this.missions[index] === 'daily-send-message') {
                this.dataDailySendMessage = value.data.body
              } else if (this.missions[index] === 'welcome-beans') {
                this.dataMissionsWelcomeBeans = value.data.body
              }
            }
          })
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getDate(date) {
      return moment(date).format('DD.MM.YYYY HH:mm:ss')
    },
    resizeChart() {
      this.$refs.myChart.resize()
    },
    formatTime(_seconds, showSeconds = false) {
      // eslint-disable-next-line radix
      const seconds = typeof _seconds === 'string' ? parseInt(_seconds.replaceAll('.', '')) : _seconds

      const hours = Math.floor(seconds / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      const secs = seconds % 60

      const formattedHours = hours.toString().padStart(2, '0')
      const formattedMinutes = minutes.toString().padStart(2, '0')
      const formattedSeconds = secs.toString().padStart(2, '0')

      return `${formattedHours}:${formattedMinutes}${showSeconds ? `:${formattedSeconds}` : ''}`
    },
    timeLeft(time) {
      if (time <= 0) return '0'

      let result = ''
      let totalSeconds = time

      const days = Math.floor(totalSeconds / (60 * 60 * 24))
      totalSeconds -= days * (60 * 60 * 24)

      const hours = Math.floor(totalSeconds / (60 * 60))
      totalSeconds -= hours * (60 * 60)

      const minutes = Math.floor(totalSeconds / (60))
      totalSeconds -= minutes * 60

      const seconds = Math.floor(totalSeconds % 60)

      // if (days > 0) {
      //   result += days + ` ${this.$t('days')}, `
      // }

      if (hours > 0) {
        result += `${hours} ${this.$t('hours')}, `
      }

      if (minutes > 0) {
        result += `${minutes} ${this.$t('minutes')}, `
      }

      if (seconds > 0) {
        result += `${seconds} ${this.$t('seconds')}, `
      }

      return _.trimEnd(result, ', ')
    },

    getRemainingTime(date, userId) {
      // Eğer userId ile hesaplanmış bir değer varsa onu döndür
      if (this.remainingTimes[userId]) {
        return this.remainingTimes[userId]
      }

      // İlk hesaplama
      return this.calculateRemainingTime(date)
    },
    calculateRemainingTime(date) {
      const now = moment()
      // Unix timestamp'i moment objesine çevir
      const expireTime = moment.unix(date)

      if (expireTime.isBefore(now)) {
        return '00:00'
      }

      const hours = expireTime.diff(now, 'hours')
      const minutes = expireTime.diff(now, 'minutes') % 60

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
    },
    updateAllRemainingTimes() {
      if (!this.dailyTasksUsers || !Array.isArray(this.dailyTasksUsers)) return

      const newRemainingTimes = {}

      this.dailyTasksUsers.forEach(user => {
        if (user.step_expire) {
          newRemainingTimes[user.uuid] = this.calculateRemainingTime(user.step_expire)
        }
      })

      this.remainingTimes = newRemainingTimes
    },
    startUpdateInterval() {
      // İlk güncelleme
      this.updateAllRemainingTimes()

      // Her saniye güncelle
      this.updateInterval = setInterval(() => {
        this.updateAllRemainingTimes()
      }, 1000)
    },
  },
}
</script>

<style lang="scss" scoped>
.special-contents-tab {
  width: 100%;
  min-width: 0;
  margin: 0 auto;
}

.rewards-page {
  .chart-container {
    max-width: 100%;
    height: 280px;
    @media (max-width: 768px) {
      height: 200px;
    }
  }
  .card-body {
    padding: 8px;
  }
  .reward-progress {
    position:relative;
    margin-bottom: 16px;

    .reward-progress-bean {
      position:absolute;
      left: 0;
      top: -8px
    }

    .reward-progress-icon {
      position: absolute;
      left: 6px;
      top: -2px;
      z-index: 2;
      color: #6F03A0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .reward-progress-bar {
      position: absolute;
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
      color: #333;
    }
  }
  .nav-link {
    a {
      font-size: 13px !important;
    }
    &.active {
      a {
        color: #ffffff !important;
      }
    }
  }
  .nav-pills .nav-link {
    padding: 0.786rem 0.35rem !important;
  }
  .reward-notification-container {
    width: 100%;
    display: flex;
    justify-content: center;

    .reward-notification {
      width: 460px;
      height: 120px;
      max-width: 100%;
      max-height: 100%;
      display: flex;
      gap: 4px;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-bottom: 12px;
      //background: url('~@/assets/images/bg/rewards-notification-bg-2.png') no-repeat center center;
      //background-size: cover !important;
      border-radius: 6px;
      position: relative;

      .image-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .reward-notification-content {
        padding: 12px 30px;
        display: flex;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .reward-notification-text, .reward-notification-title {
          margin-bottom: 0;
          text-align: center;
        }

        .reward-notification-title {
          font-size: 15px;
          color: #272727;
          font-weight: bold;
          line-height: 1.1 !important;
        }
        .reward-notification-text {
          color: #272727;
          font-size: 11px;
          line-height: 1.1 !important;
        }

        @media (max-width: 768px) {
          .reward-notification-title {
            font-size: 12px;
          }
          .reward-notification-text {
            font-size: 10px;
          }
        }
      }
    }
  }
  .daily-task {
    font-family: 'Inter', sans-serif !important;

    .daily-task-title {
      display: flex;
      font-size: 13px !important;
      color: #fff !important;
      align-items: center;
      gap: 6px;
      margin-bottom: 12px;
      justify-content: center;

      p {
        margin-bottom: 0 !important;
      }

      .daily-task-earnings-amount {
        display: flex;
        align-items: center;
        padding: 4px 16px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 10px;
        gap: 4px;
      }
    }

    .daily-task-description {
      p {
        font-size: 16px;
        text-align: center;
      }
    }

    .member-tabs {
      display: flex;
      width: 100%;
      min-width: 0;
      flex-wrap: wrap;
      gap: 8px;
      justify-content: center;
      padding: 10px 0;

      .member-tab-btn {
        background: white;
        border-radius: 16px;
        padding: 6px 8px !important;
        font-weight: 600;
        font-size: 12px !important;
        cursor: pointer;
        transition: all 0.2s ease;
        color: #6F03A0;
        display: flex;
        flex: 0 1 auto;
        max-width: 100%;
        align-items: center;
        justify-content: center;
        text-align: center;

        &:hover {
          transform: translateY(-2px);
        }

        &.active {
          background: linear-gradient(to bottom, #D272FF 0%, #FF4E8E 100%);
          color: white;
        }
      }
    }

    /* Responsive Design */
    @media (max-width: 768px) {
      .special-contents-tab {
        width: 100%;
        padding: 0;
      }

      .member-tabs {
        gap: 8px;

        .member-tab-btn {
          font-size: 14px;
        }
      }
    }

    .user-card {
      width: 100%;
      padding: 12px;
      background-color: #F4F7FB !important;
      border-radius: 18px;
      display: flex;
      justify-content: space-between;
      color: #000000 !important;
      position: relative;
      margin-top: 4px;

      .profile {
        display: flex;
        align-items: center;
        gap: 6px;
        .image {
          position: relative;
          overflow: hidden;
          width: 42px;
          height: 42px;
          .user-image {
            border-radius: 12px;
          }
        }
        .username-country {
          display: flex;
          flex-direction: column;
          gap: 5px;
          justify-content: center;
          .username {
            font-size: 16px;
            margin-bottom: 0;
            line-height: 1;
            max-width: 230px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .country {
            font-size: 12px;
            font-weight: 300;
            margin-bottom: 0;
            line-height: 1;
          }
        }
      }
      .label {
        display: flex;
        align-items: center;
        font-size: 12px;

        .indicator {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #0bb708;
          margin-right: 3px;
        }
      }
      .actions {
        display: flex;
        align-items: center;
        gap: 4px;
        div {
          cursor: pointer;
          border: 1px solid #DB34F3;
          padding: 8px;
          border-radius: 50%;
        }
      }

      .user-card-timer {
        font-family: 'Lexend', sans-serif !important;
        position: absolute;
        top: -15px;
        left: 50%;
        transform: translateX(-50%);
        padding: 5px 10px;
        background-color: #A403ED;
        border-radius: 16px;
        color: #fff;
        font-size: 13px;
        display: flex;
        gap: 4px;
        align-items: center;
      }
    }
    .user-card-bottom {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      background-color: #F4F7FB !important;
      border-radius: 18px;
      margin-bottom: 10px;
      padding: 14px 6px;
      margin-top: -16px;
      margin-left: 8px;
      max-width: calc(100% - 16px);

      .user-card-bottom-levels {
        position: relative;
        width: 100%;
        margin-bottom: 10px;
        .progress-tracker-container {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          padding: 20px;
          max-width: 900px;
          margin: auto;
        }

        .steps-wrapper {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
        }

        .step-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          flex: 1; /* Her adımın eşit genişlikte olmasını sağlar */
          text-align: center;
        }

        .step-graphic {
          display: flex;
          align-items: center;
          width: 100%;
        }

        .line {
          flex-grow: 1;
          height: 6px;
          background-color: #32FCE9;

          &.gray-line {
            background-color: #D9D9D9;
          }
        }

        /* İlk ve son adımdaki çizgileri gizlemek için */
        .line.invisible {
          background-color: transparent;
        }

        .circle {
          width: 16px;
          height: 16px;
          background: #0BDE86;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-shrink: 0; /* Dairenin küçülmesini engeller */
          z-index: 2;
          position: relative;

          &.gray-circle {
            background: #D9D9D9;
          }
        }

        .check-icon {
          width: 32px;
          height: 32px;
        }

        /* SVG Animasyonu için CSS (isteğe bağlı ama şık durur) */
        .checkmark__check {
          stroke-dasharray: 48;
          stroke-dashoffset: 48;
          stroke: #fff;
          stroke-width: 4;
          stroke-linecap: round;
          stroke-linejoin: round;
          animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.5s forwards;
        }

        @keyframes stroke {
          100% {
            stroke-dashoffset: 0;
          }
        }

        .step-info {
          margin-top: 15px;
        }

        .step-title {
          font-size: 12px;
          color: #4a4a4a;
          height: 28px;
          display: flex;
          align-items: center;
        }

        .step-reward {
          margin-top: 8px;
          font-size: 10px;
          font-weight: 500;
          color: #009981;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
        }

        .reward-icon {
          margin-left: 8px;
          font-size: 11px;
        }
      }
      .user-card-bottom-description {
        text-align: center;
        color: #009981 !important;
        font-size: 11px !important;
      }
    }
  }

  /* Kullanıcı listesi - sadece liste (generally) */
  .rewards-user-list {
    width: 100%;
    margin-bottom: 24px;
  }

  .rewards-user-list-grid {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .rewards-user-card {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 14px 18px;
    background-color: #F4F7FB;
    border-radius: 18px;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
    color: #000;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    }
  }

  .rewards-user-card__avatar-wrap {
    position: relative;
    flex-shrink: 0;
    width: 56px;
  }

  .rewards-user-card__info {
    flex: 1;
    min-width: 0;
  }

  .rewards-user-card__info-top {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .rewards-user-card__name {
    font-size: 16px;
    font-weight: 600;
    color: #000;
  }

  .rewards-user-card__status {
    font-size: 12px;

    &--online,
    &--recent {
      color: #0bb708;
    }

    &--today {
      color: #f59e0b;
    }

    &--week,
    &--old {
      color: #6b7280;
    }
  }

  .rewards-user-card__meta {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 4px;
  }

  .rewards-user-card__flag {
    border-radius: 4px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  .rewards-user-card__actions {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .rewards-user-card__action {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border: 1px solid #DB34F3;
    border-radius: 50%;
    color: #DB34F3;

    &--call {
      border-color: #0bb708;
      color: #0bb708;
      cursor: pointer;
      transition: background 0.2s, color 0.2s;

      &:hover {
        background: #0bb708;
        color: #fff;
      }
    }
  }

  .rewards-user-list-sentinel {
    height: 1px;
    visibility: hidden;
    margin-top: 16px;
  }

  .rewards-user-list-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 16px;
    color: #6b7280;
    font-size: 14px;
  }

  .rewards-user-list-end {
    text-align: center;
    padding: 16px;
    font-size: 13px;
    color: #6b7280;
  }

  .inactive-reason-alert {
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(255, 78, 78, 0.12);
    border: 1px solid rgba(255, 78, 78, 0.35);
    border-radius: 10px;
    padding: 10px 14px;
    font-size: 13px;
    color: #ff4e4e;
    margin-bottom: 12px;

    .inactive-reason-icon {
      flex-shrink: 0;
    }
  }

  .no-data-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    text-align: center;
  }

  .no-data-icon {
    margin-bottom: 24px;
    opacity: 0.6;
  }

  .no-data-title {
    font-size: 20px;
    font-weight: 600;
    color: #e6e6e6;
    margin-bottom: 8px;
  }

  .no-data-description {
    font-size: 14px;
    color: #c1c4c8;
    margin: 0;
  }

  .campaign-banner-container {
    width: 100%;
    display: flex;
    justify-content: center;
    .campaign-banner {
      display: flex;
      position: relative;
      text-align: center;
      height: 110px;
      width: 420px;
      max-width: 105%;
      margin-left: -2.5%;
      border-radius: 10px;
      background-size: contain;
      margin-bottom: 8px;
      flex-direction: column;
      align-items: center;

      &.bg-1 {
        background: url('~@/assets/images/bg/reward-welcome-bonus-bg.jpg') center center no-repeat;
        color: #fff;
        padding: 24px 32px;
        font-size: 20px;
        font-family: 'Poppins', sans-serif;
      }

      &.bg-2 {
        background: url('~@/assets/images/bg/reward-welcome-bonus-bg-2.png') center center no-repeat;
        border-radius: 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 24px;

        .top-text {
          font-size: 13px;
          font-family: 'Poppins', sans-serif;
          color: #A403ED;
          background-color: #fff;
          border-radius: 32px;
          padding: 2px 12px;
          position: absolute;
          top: -6px;
          left: 50%;
          transform: translateX(-50%);
          max-width: 320px;
          height: 28px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        p {
          color: #fff;
          font-size: 14px;
          margin-bottom: 3px;
        }

        .progress {
          background: #210030;
        }

        .reward-progress-bar {
          color: #fff !important;
        }
      }
    }
  }
}
</style>

<style lang="scss">
/* Boho koyu tema katmanı (sadece görünüm) */
@import '~@/assets/scss/boho-rewards.scss';
</style>
